import axios from "axios";
import { validateUserLogin } from "src/util/auth.util";
import {
  store as authStore,
  isLoginAtom,
  loginStepAtom,
} from "src/atoms/authAtom";
import routs from "src/router/routs";
export const unauthorized = axios.create({
  baseURL: `${import.meta.env.VITE_API_BASE_URL}`,
  headers: {
    "Content-Type": "application/json",
  },
});

export const authorized = axios.create({
  baseURL: `${import.meta.env.VITE_API_BASE_URL}`,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

authorized.interceptors.request.use(async (reqConf) => {
  const accessToken = localStorage.getItem("access-token");
  if (!validateUserLogin()) {
    authStore.set(isLoginAtom, false);
    authStore.set(loginStepAtom, "phoneNumber");
    routs.navigate("/login");
    throw new Error("Token Expired!");
  }
  reqConf.headers["Authorization"] = `Bearer ${accessToken}`;
  return reqConf;
});
